import React, { useRef, useEffect, useState, useCallback } from "react";
import Backend from "../../../Backend/Backend";
import { toast } from "react-toastify";
import useSize from "../../useSize/useSize";
import Filter from "./Filter/Filter";
import Loading from "../../Loading/Loading";
import NotFound from "../../NotFound/NotFound";
import Menu from "./Menu/Menu";
import UserCard from "./UserCard";
import { toJpeg } from "html-to-image";

const backend = await new Backend().init();

export default function UserList({ user_id }) {
  const windowSize = useSize();
  const elementRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [broker, setBroker] = useState(null);
  const [user, setUser] = useState([]);

  const loadBrokerUser = useCallback(async () => {
    setLoading(true);

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      broker_id: user_id,
    };

    try {
      const r = await backend.load_broker_user(data);
      if (r.error === "False") {
        setUser(r.userlist || []);
        setBroker(r.broker || null);
      } else {
        toast.error(r.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  }, [user_id]);

  useEffect(() => {
    loadBrokerUser();
  }, [loadBrokerUser]);

  const htmlToImageConvert = useCallback(() => {
    if (!elementRef.current || !broker) return;

    toJpeg(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = `${broker.username}-USER-LIST.jpeg`;
        link.href = dataUrl;
        link.click();
      })
      .catch(console.error);
  }, [broker]);

  return (
    <div
      style={{
        width: windowSize[0] - 100,
        height: windowSize[1] - 170,
      }}
    >
      <Filter records={user.length} htmlToImageConvert={htmlToImageConvert} />

      <div ref={elementRef}>
        {broker && <Menu broker={broker} />}

        <div
          style={{
            height: windowSize[1] - 330,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {loading ? (
            <Loading height={windowSize[1] - 330} />
          ) : user.length > 0 ? (
            <div
              style={{
                height: windowSize[1] - 330,
                overflowY: "auto",
              }}
            >
              {user.map((item) => (
                <UserCard key={item.id} item={item} broker={broker} />
              ))}
            </div>
          ) : (
            <NotFound
              height={windowSize[1] - 330}
              title="Nothing here"
              subtext="No Login History Found."
            />
          )}
        </div>
      </div>
    </div>
  );
}
